





















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import TramiteReevaluacionHogar from "@/models/tramite/reevaluacion-hogar/reevaluacion-hogar.model";
import PersonaDireccion from "@/models/persona/personaDireccion.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Hogar from "@/models/hogar/hogar.model";
import Direccion from "@/models/direccion.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";

@Component({
  components: {
    DatePickerComponent
  }
})
export default class ReevaluacionHogar extends BaseVue {
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;

  // @Prop() readonly hogarId!: number;
  @Prop() readonly codigoHogar!: string;
  @Prop() readonly cedula!: string;
  @Prop() readonly content!: TramiteBeneficiario;

  direccionesTableConfig!: BTableConfig<PersonaDireccion>;
  direccionPropuestaInit = new Direccion();
  direccionPropuesta = this.map<Direccion>(this.direccionPropuestaInit);
  icv: any = null;
  fechaLevantamiento: any = new Date();
  constructor() {
    super();
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }
  get personaId() {
    if (this.beneficiario && this.beneficiario.personaId) return this.beneficiario.personaId;

    if (this.solicitante && this.solicitante.id) return this.solicitante.id;

    return 0;
  }

  @Watch("icv")
  onICV() {
    let contenido = this.content as any;
    if (contenido) {
      if (contenido.tramiteReevaluacionHogar) {
        contenido.tramiteReevaluacionHogar.icv = this.icv;
        contenido.tramiteReevaluacionHogar.fechaLevantamiento = this.fechaLevantamiento;
        this.$emit("update:content", contenido);
      }
    }
  }
  @Watch("fechaLevantamiento")
  onFechaLevantamiento() {
    let contenido = this.content as any;
    if (contenido) {
      if (contenido.tramiteReevaluacionHogar) {
        contenido.tramiteReevaluacionHogar.icv = this.icv;
        contenido.tramiteReevaluacionHogar.fechaLevantamiento = this.fechaLevantamiento;
        this.$emit("update:content", contenido);
      }
    }
  }

  created() {
    //let props = [];
    // props.push(
    //   // new TipoTramiteComponentProp("hogarId", "number"),
    //   // new TipoTramiteComponentProp("personaId", "number"),
    //   new TipoTramiteComponentProp("codigoHogar", "string"),
    //   new TipoTramiteComponentProp("cedula", "string")
    // );
    this.$emit("render", []);
  }
  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido.tramiteReevaluacionHogar)
        delete contenido.tramiteReevaluacionHogar;
      this.$emit("update:content", contenido);
    }
  }
  onSelect(selected: PersonaDireccion, oldSelected: PersonaDireccion) {
    this.direccionPropuesta = selected.direccion as Direccion;
    this.set(this.direccionPropuesta.id);
  }

  onAdd(added: PersonaDireccion) {
    this.direccionPropuesta = added.direccion as Direccion;
    this.set(this.direccionPropuesta.id);
  }

  onLoadTable(config: BTableConfig<PersonaDireccion>) {
    this.direccionesTableConfig = config;
  }
  quitDireccion() {
    this.direccionPropuesta = this.map<Direccion>(this.direccionPropuestaInit);
    this.direccionesTableConfig.selection.selected = null;
    this.set();
  }
  set(id?: number) {
    let contenido = this.content as any;
    if (id) {
      let model = new TramiteReevaluacionHogar(id);
      if (this.beneficiario) {
        model.personaId = this.beneficiario.personaId;
        model.hogarId = this.beneficiario.hogarId;
        model.icv = this.icv;
        model.fechaLevantamiento = this.fechaLevantamiento;
      }
      contenido.tramiteReevaluacionHogar = model;
    } else delete contenido.tramiteReevaluacionHogar;

    this.$emit("update:content", contenido);
  }

  hogar = new Hogar();
  repoHogar = new BaseRepository<Hogar>("hogar");
  @Watch("beneficiario", { immediate: true, deep: true })
  async onBeneficiarioChange(value: Beneficiario) {
    if (value) {
      this.hogar =
        (await this.repoHogar.one(`id=${value.hogarId}`)) || new Hogar();
    }
  }
  // @Watch("codigoHogar", { immediate: true })
  // async onCodigoHogarChange(value: string) {
  //   if (value) {
  //     this.hogar =
  //       (await this.repoHogar.one(`codigo="${value}"`)) || new Hogar();
  //   }
  // }
}
